import React, { useCallback, useEffect, useState } from "react";
import Playlist from "./sections/Playlist";
import PageDescription from "./sections/PageDescription";
import SpotifyIcon from "../../../assets/images/admin/Spotify.svg";
import AppleIcon from "../../../assets/images/admin/Apple.svg";
import UIcon from "../../../assets/images/icons/u-icon.png";
import StartIcon from "../../../assets/images/admin/Star.svg";
import StarIcon from "../../../assets/images/admin/Star-outlined.svg";
import GroupIcon from "../../../assets/images/admin/Group-line.svg";
import InstaIcon from "../../../assets/images/admin/Instagram.png";
import TiktokIcon from "../../../assets/images/admin/Tiktok.png";
import YoutubeIcon from "../../../assets/images/admin/Youtube.png";
import TracksDetail from "./sections/components/TracksDetail";
import PageContent from "./sections/PageContent";
import InsightSection from "./sections/InsightSection";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actions from "../../../redux/actions/dataAnalyst";
import {
  getArtistChartStats,
  getArtistStats,
} from "../../../redux/actions/artistDetails";
import { useDispatch, useSelector } from "react-redux";
import { formatDateToMonthDay, getArtistNames } from "../../../helper/utility";
import { getIconFromSource, useArtistStats } from "./datahooks";
import { getCustomerPortalSession } from "../../../redux/actions";
import { PricingPlanModal } from "../../../components/PricingPlanModal";
import DummyTrackCard from "../../../components/DummyTrackCard";
import { useLocation } from "react-router-dom";
import AppTour from "../../../components/AppTour/AppTour";
import { milestonesTourSteps } from "../../../components/AppTour/ModuleTourSteps";
import { useTrackFirstVisit, ACTIVITY_TYPES } from "../../../hooks/useTrackFirstVisit";
import { useTrackModuleVisit, MODULE_VISIT_TYPES } from "../../../hooks/useTrackModuleVisit";

const periodOptions = [
  { value: "all", label: "All time performance" },
  { value: "weekly", label: "Weekly performance" },
  { value: "monthly", label: "Monthly performance" },
  { value: "yearly", label: "Yearly performance" },
];

const milestonePlatforms = [
  { icon: UIcon, alt: "upncomer", name: "all" },
  { icon: SpotifyIcon, alt: "Spotify", name: "spotify" },
  { icon: InstaIcon, alt: "Instagram", name: "instagram" },
  { icon: TiktokIcon, alt: "Tiktok", name: "tiktok" },
  { icon: YoutubeIcon, alt: "YouTube", name: "youtube" },
  { icon: GroupIcon, alt: "Group", name: "soundcloud" },
];

const statsPlatforms = [
  { icon: UIcon, alt: "upncomer", name: "all" },
  { icon: SpotifyIcon, alt: "Spotify", name: "spotify" },
  { icon: AppleIcon, alt: "Apple Music", name: "apple_music" },
  { icon: StartIcon, alt: "Star", name: "itunes" },
  // { icon: GroupIcon, alt: "Group", name: "soundcloud" },
];

const chartsPlatforms = [
  { icon: UIcon, alt: "upncomer", name: "all" },
  { icon: StartIcon, alt: "Star", name: "itunes" },
  { icon: SpotifyIcon, alt: "Spotify", name: "spotify" },
  { icon: AppleIcon, alt: "Apple Music", name: "apple_music" },
];

const sampleTracks = [
  {
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=80&h=80&fit=crop',
    name: 'Summer Vibes',
    artist: 'The Wave Makers',
    date: '2024-03-15',
    label: 'Ocean Records',
    channel: 'Spotify',
    icon: null
  },
  {
    image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=80&h=80&fit=crop',
    name: 'Midnight Dreams',
    artist: 'Luna Eclipse',
    date: '2024-02-20',
    label: 'Stellar Music',
    channel: 'Apple Music',
    icon: null
  },
  {
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=80&h=80&fit=crop',
    name: 'Electric Pulse',
    artist: 'Neon Knights',
    date: '2024-01-10',
    label: 'Synth Wave Records',
    channel: 'YouTube',
    icon: null
  }
];

function Milestones() {
  const dispatch = useDispatch();
  const { hash } = useLocation()
  const [runTour, setRunTour] = useState(false)
  useTrackFirstVisit(ACTIVITY_TYPES.DATA_ANALYST_MILESTONES_FIRST_VISIT);
  useTrackModuleVisit(MODULE_VISIT_TYPES.DATA_ANALYST, "milestones");
  const [selectedTrack, setSelectedTrack] = useState("");
  const [loadMilestones, setLoadMilestones] = useState(false);
  const [loadArtistData, setLoadArtistData] = useState(false);
  const [showPricingPlanModal, setShowPricingPlanModal] = React.useState(false);
  const [loadPlaylists, setLoadPlaylists] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = React.useState(
    periodOptions[0].value
  );
  const [selectedPlatform, setSelectedPlatform] = React.useState("all");
  const [selectedArtistPlatform, setSelectedArtistPlatform] = React.useState("all");
  const [selectedPlaylists, setSelectedPlaylists] = React.useState("all");
  const artistDetails = useSelector((state) => state.artistDetails);
  const reducersData = useSelector((state) => state.dataanalyst);
  const {
    hasActiveSubscription
  } = useSelector((state) => state.billing);
  const { artistStats, artistChartStats } = artistDetails;
  const {
    milestoneActivities,
    playlistActivities,
    artistStatsBySource,
    artistChartStatsBySource,
    searchQuery,
    milestoneSearchQuery,
    playlistSearchQuery,
    failedTrackActivities
  } = reducersData;

  const milestoneState = milestoneActivities?.data ? milestoneActivities : (Array.isArray(milestoneActivities) ? { data: milestoneActivities } : { data: [] });
  const playlistState = playlistActivities?.data ? playlistActivities : (Array.isArray(playlistActivities) ? { data: playlistActivities } : { data: [] });

  const milestones =
    milestoneState?.data?.length > 0
      ? milestoneState?.data?.filter(
        (milestone) =>
          ["spotify", "instagram", "youtube", "tiktok", "soundcloud"].includes(milestone.source) &&
          ["milestone", "video", "source_video"].includes(milestone.activity_type)
      )
      : [];

  const playlists =
    playlistState?.data?.length > 0
      ? playlistState?.data?.filter(
        (milestone) =>
          ["playlist", "editorial_playlist", "album_chart", "track_chart", "album_feature_chart"].includes(milestone.activity_type)
      )
      : [];

  const [isLoadingMoreMilestones, setIsLoadingMoreMilestones] = useState(false);
  const [isLoadingMorePlaylists, setIsLoadingMorePlaylists] = useState(false);
  const filteredPlaylists = failedTrackActivities === 'fails'
    ? playlists?.filter(playlist => {
      const firstWord = searchQuery?.name?.split(" ")[0]?.toLowerCase();
      const title = playlist?.track_info?.title?.toLowerCase();
      return firstWord && title?.includes(firstWord);
    })
    : playlists;

  useEffect(() => {
    if (hash === "#start-tour") {
      setRunTour(true)
    }
  }, [hash])

  useEffect(() => {
    if (hasActiveSubscription) {
      let queryParams = { type: selectedPeriod };
      dispatch(
        actions.getMilestoneActivities(toast, { source: 'all' }, "MILESTONE", setLoadMilestones)
      );
      dispatch(
        actions.getMilestoneActivities(toast, { source: 'all' }, "PLAYLIST", setLoadPlaylists)
      );
      if (selectedArtistPlatform === "all") {
        dispatch(getArtistStats(toast, queryParams, setLoadArtistData));
        dispatch(getArtistChartStats(toast, queryParams));
      } else {
        dispatch(
          actions.getArtistStatsBySources(
            toast,
            { type: selectedPeriod, source: selectedArtistPlatform },
            setLoadArtistData
          )
        );
        dispatch(
          actions.getArtistChartStatsBySource(toast, {
            type: selectedPeriod,
            source: selectedArtistPlatform,
          })
        );
      }
    }
  }, [dispatch, hasActiveSubscription]);

  const loadMoreMilestones = useCallback(() => {
    const next = milestoneState?.nextOffset;
    if (next && !isLoadingMoreMilestones) {
      setIsLoadingMoreMilestones(true);
      if (milestoneSearchQuery?.id) {
        dispatch(actions.getTrackActivities(
          toast,
          { spotify_track_id: milestoneSearchQuery.id, source: selectedPlatform, offset: next },
          "MILESTONE",
          (v) => {
            if (typeof v === 'boolean') setIsLoadingMoreMilestones(v);
          }
        )).finally(() => setIsLoadingMoreMilestones(false));
      } else {
        dispatch(actions.getMilestoneActivities(
          toast,
          { source: selectedPlatform, offset: next },
          "MILESTONE",
          (v) => {
            if (typeof v === 'boolean') setIsLoadingMoreMilestones(v);
          }
        )).finally(() => setIsLoadingMoreMilestones(false));
      }
    }
  }, [dispatch, milestoneState, selectedPlatform, isLoadingMoreMilestones]);

  const loadMorePlaylists = useCallback(() => {
    const next = playlistState?.nextOffset;
    if (next && !isLoadingMorePlaylists) {
      setIsLoadingMorePlaylists(true);
      if (playlistSearchQuery?.id) {
        dispatch(actions.getTrackActivities(
          toast,
          { spotify_track_id: playlistSearchQuery.id, source: selectedPlaylists, offset: next },
          "PLAYLIST",
          (v) => {
            if (typeof v === 'boolean') setIsLoadingMorePlaylists(v);
          }
        )).finally(() => setIsLoadingMorePlaylists(false));
      } else {
        dispatch(actions.getMilestoneActivities(
          toast,
          { source: selectedPlaylists, offset: next },
          "PLAYLIST",
          (v) => {
            if (typeof v === 'boolean') setIsLoadingMorePlaylists(v);
          }
        )).finally(() => setIsLoadingMorePlaylists(false));
      }
    }
  }, [dispatch, playlistState, selectedPlaylists, isLoadingMorePlaylists]);

  const handleMilestonePlatformChange = useCallback(
    (platform) => {
      setSelectedPlatform(platform);
      if (hasActiveSubscription) {
        if (milestoneSearchQuery?.id) {
          const queryParam = {
            spotify_track_id: milestoneSearchQuery?.id,
            source: platform,
          };
          dispatch(actions.getTrackActivities(toast, queryParam, "MILESTONE"));
        } else {
          dispatch(
            actions.getMilestoneActivities(
              toast,
              { source: platform },
              "MILESTONE",
              setLoadMilestones
            )
          );
        }
      } else {
        alert("Please Subscribe a Plan to see your data")
      }
    },
    [dispatch, selectedPlatform, milestoneSearchQuery, hasActiveSubscription]
  );

  const handlePlaylistsPlatformChange = useCallback(
    (platform) => {
      setSelectedPlaylists(platform);
      if (hasActiveSubscription) {
        if (playlistSearchQuery?.id) {
          const queryParam = {
            spotify_track_id: playlistSearchQuery?.id,
            source: platform,
          };
          dispatch(actions.getTrackActivities(toast, queryParam, "PLAYLIST"));
        } else {
          dispatch(
            actions.getMilestoneActivities(
              toast,
              { source: platform },
              "PLAYLIST",
              setLoadPlaylists
            )
          );
        }
      } else {
        alert("Please Subscribe a Plan to see your data")
      }
    },
    [dispatch, playlistSearchQuery, selectedPlaylists, hasActiveSubscription]
  );

  const onPeriodChange = useCallback(
    (value) => {
      const period = typeof value === 'object' ? value.target.value : value;
      setSelectedPeriod(period);
      if (hasActiveSubscription) {
        if (searchQuery?.id) {
          const queryParam = {
            spotify_track_id: searchQuery?.id,
            type: period,
            source: selectedArtistPlatform === "all" ? "spotify" : selectedArtistPlatform,
          };
          dispatch(actions.getTrackStats(toast, queryParam, true));
          dispatch(actions.getTrackChartsStats(toast, queryParam, true));
        } else {
          if (selectedArtistPlatform === "all") {
            let queryParams = { type: period };
            dispatch(getArtistStats(toast, queryParams, setLoadArtistData));
            dispatch(getArtistChartStats(toast, queryParams));
          } else {
            dispatch(
              actions.getArtistStatsBySources(
                toast,
                { type: period, source: selectedArtistPlatform },
                setLoadArtistData
              )
            );
            dispatch(
              actions.getArtistChartStatsBySource(toast, {
                type: period,
                source: selectedArtistPlatform,
              })
            );
          }
        }
      } else {
        alert("Please Subscribe a Plan to see your data")
      }
    },
    [dispatch, selectedArtistPlatform, searchQuery, toast, hasActiveSubscription]
  );

  const handleStatsPlatformChange = useCallback(
    (platform) => {
      setSelectedArtistPlatform(platform);
      if (hasActiveSubscription) {
        if (searchQuery?.id) {
          const queryParam = {
            spotify_track_id: searchQuery?.id,
            type: selectedPeriod,
            source: platform === "all" ? "spotify" : platform,
          };
          dispatch(actions.getTrackStats(toast, queryParam, true));
          dispatch(actions.getTrackChartsStats(toast, queryParam, true));
        } else {
          if (platform === "all") {
            let queryParams = { type: selectedPeriod };
            dispatch(getArtistStats(toast, queryParams, setLoadArtistData));
            dispatch(getArtistChartStats(toast, queryParams));
          } else {
            dispatch(
              actions.getArtistStatsBySources(
                toast,
                { type: selectedPeriod, source: platform },
                setLoadArtistData
              )
            );
            dispatch(
              actions.getArtistChartStatsBySource(toast, {
                type: selectedPeriod,
                source: platform,
              })
            );
          }
        }
      } else {
        alert("Please Subscribe a Plan to see your data")
      }
    },
    [dispatch, selectedPeriod, searchQuery, toast, hasActiveSubscription]
  );

  const artistMetrics = useArtistStats(
    selectedArtistPlatform === "all" || searchQuery?.id
      ? artistStats
      : artistStatsBySource,
    selectedArtistPlatform === "all" || searchQuery?.id
      ? artistChartStats
      : artistChartStatsBySource?.all_data,
    selectedPeriod,
    selectedArtistPlatform,
    searchQuery?.id
  );
  const getTrack = useCallback((e) => {
    setSelectedTrack(e);
  },
    [selectedPlatform, dispatch, toast]
  );

  const handleProClick = async () => {
    try {
      setLoadMilestones(true);
      if (hasActiveSubscription) {
        await dispatch(getCustomerPortalSession());
      } else {
        setShowPricingPlanModal(true);
      }
    } catch (err) {
      console.error('Error handling Pro button:', err);
    } finally {
      setLoadMilestones(false);
    }
  };

  return (
    <div className="DataAnalyst-page py-5">
      <AppTour
        tourSteps={milestonesTourSteps}
        runTour={runTour}
        setRunTour={setRunTour}
      />
      <div className="container max-w-full">
        <PageDescription
          title="Milestones"
          description="Your biggest achievements across all platforms."
          withBackOption
          withForwardOption
          link={'/admin/data-analyst/radioplay'}
          tooltipText='Go to Radio Play'
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4">
          <div className="grid-item xl:row-span-3" data-tour="milestones">
            <Playlist
              icon={StarIcon}
              title="Milestones"
              platforms={milestonePlatforms}
              onPlatformsChange={handleMilestonePlatformChange}
              activity_type={"MILESTONE"}
              isLoading={loadMilestones}
              selectedPlatform={selectedPlatform}
              hasMore={milestoneState?.hasMore}
              isLoadingMore={isLoadingMoreMilestones}
              onLoadMore={loadMoreMilestones}
              onProClick={handleProClick}
              showMilestones={true}
              withSearch
            >
              <div className="w-full flex flex-col gap-2">
                {hasActiveSubscription && milestones?.length > 0 ? (
                  milestones?.map((item, index) => (
                    <TracksDetail
                      key={index}
                      trackData={{
                        image: item.track_info.avatar,
                        name: item.track_info.title,
                        artist: getArtistNames(item.track_info.artists),
                        streams: item.streams_total,
                        label: item.activity_text,
                        date: formatDateToMonthDay(item.activity_date),
                        icon: getIconFromSource(item.source),
                        link: item.track_info.site_url,
                      }}
                    />
                  ))
                ) : (
                  hasActiveSubscription ?
                    <span className="text-center text-white">
                      No Data available
                    </span> :
                    sampleTracks.map((track, index) => (
                      <DummyTrackCard
                        key={index}
                        trackData={track}
                        isPro={false}
                        onProClick={handleProClick}
                      />
                    ))
                )}
              </div>
            </Playlist>
          </div>
          <div className="grid-item xl:row-span-3" data-tour="playlists-charts">
            <Playlist
              icon={StarIcon}
              title="Playlists + Charts"
              platforms={chartsPlatforms}
              onPlatformsChange={handlePlaylistsPlatformChange}
              activity_type={"PLAYLIST"}
              isLoading={loadPlaylists}
              hasMore={playlistState?.hasMore}
              isLoadingMore={isLoadingMorePlaylists}
              onLoadMore={loadMorePlaylists}
              hasActiveSubscription={hasActiveSubscription}
              onProClick={handleProClick}
              selectedPlatform={selectedPlaylists}
              showMilestones={false}
              withSearch
            >
              <div className="w-full flex flex-col gap-2">
                {hasActiveSubscription && filteredPlaylists?.length > 0 ? (
                  filteredPlaylists?.map((item, index) => (
                    <TracksDetail
                      key={index}
                      trackData={{
                        image: item.track_info.avatar,
                        name: item.track_info.title,
                        artist: getArtistNames(item.track_info.artists),
                        streams: item.streams_total,
                        label: item.activity_text,
                        date: formatDateToMonthDay(item.activity_date),
                        link: item.track_info.site_url,
                      }}
                    />
                  ))
                ) : (
                  hasActiveSubscription ?
                    <span className="text-center text-white">
                      No Data available
                    </span> :
                    sampleTracks.map((track, index) => (
                      <DummyTrackCard
                        key={index}
                        trackData={track}
                        isPro={false}
                        onProClick={handleProClick}
                      />
                    ))
                )}
              </div>
            </Playlist>
          </div>
        </div>
        <div className="flex flex-1 gap-4">
          <div className="w-[75%]" data-tour="tracks-performance">
            <PageContent
              periodOptions={periodOptions}
              selectedPeriod={selectedPeriod}
              onPeriodChange={(e) => onPeriodChange(e.target.value)}
              platforms={statsPlatforms}
              onPlatformsChange={(e) => handleStatsPlatformChange(e)}
              metrics={artistMetrics}
              selectedPlatform={selectedArtistPlatform}
              hasActiveSubscription={hasActiveSubscription}
              withSearch
              isLoading={loadArtistData}
              searchPlaceholder="Search"
              setTrack={getTrack}
              forArtist
              isMarginBottom
            />
          </div>
          <div className="w-[25%] mb-5" data-tour="amplitude-insights">
            <InsightSection
              topTrack={artistStatsBySource?.topTrack}
              hasActiveSubscription={hasActiveSubscription}
              onProClick={handleProClick}
            />
          </div>
        </div>
      </div>
      <PricingPlanModal isOpen={showPricingPlanModal} onClose={() => setShowPricingPlanModal(false)} returnUrl={window.location.origin + "/admin/data-analyst/milestones"} />
    </div>
  );
}

export default Milestones;
